import React from 'react';

import SpriteIcon from 'web/components/common/icon/SpriteIcon';

import classNames from 'classnames/bind';
import styles from './Text.scss';
const cx = classNames.bind(styles);

const Text = React.memo(
  ({
    tabIndex = '0',
    type = '',
    name = '',
    value = '',
    autoComplete = 'off',
    refObj,
    style = {},
    placeholder = '',
    validation = null,
    error = '',
    onChange,
    onBlur,
    kindType,
  }) => {
    return (
      <div
        className={cx(
          'Text',
          name,
          `validation-${validation}`,
          `error-${error ? true : false}`,
        )}
        style={style}
      >
        <input
          tabIndex={tabIndex}
          type={type}
          name={name}
          value={value}
          ref={refObj}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          id={'input-' + name}
          autoComplete={autoComplete}
        />
        {name !== 'nickname' && validation ? (
          <SpriteIcon
            name={`img-ip-check`}
            style={{ position: 'absolute', right: '10px', top: '17px' }}
          />
        ) : null}
        {error ? <div className="error">{error}</div> : null}
        {validation && validation.email === '' && kindType === 'vertify' && (
          <div className="error">가입된 휴대폰번호가 아닙니다.</div>
        )}
      </div>
    );
  },
);

export default Text;
